import {Query, CloudObject, registerBrick} from 'olympe';
import {ReactBrick, useProperty} from '@olympeio/core';
import React from 'react';
import {FiltersAutocomplete} from '../shared/FiltersAutocomplete.jsx';
import {getLookupDataSF} from './GetLookupDataSF';
import {SFFilterType} from '../shared/_filters';
import DropdownConfig from '../shared/filters/DropdownConfig';
export default class SFFiltersAutocomplete extends ReactBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} properties
     * @return {Element}
     */

    static getReactComponent($) {
        return (props) => {
            const entity = useProperty($, 'Entity');
            const selectedFilters = useProperty($, 'Selected Filters') || {};
            const disabled = useProperty($, 'Disabled');
            /** @type {DropdownConfig}*/
            const dropdownOptionsType = useProperty($, 'Dropdown Config');
            let dropdownOptions = [];
            // get the selected values for that filter entity
            const selectionForEntity = selectedFilters[entity] || {};
            const selectedOptions = selectionForEntity.values || [];
            const showSelectAll = selectionForEntity.selectedAll || false;
            const limitCheck = useProperty($, 'Limit Check');


            const componentId = `SFFiltersAutocomplete_${entity}`;

            if (dropdownOptionsType?.followSingle(CloudObject.extendRel).executeFromCache().getTag()
                === DropdownConfig.asInstance().getTag()) {
                const results= Query.instancesOf(dropdownOptionsType).executeFromCache().toArray();
                const filtered = results.filter(cObject => JSON.parse((/**@type {string}*/ cObject.get(DropdownConfig.jsonProp))).entity === entity)
                const jsonString = filtered[0].get(DropdownConfig.jsonProp);
                // const jsonString = Query
                //     .instancesOf(dropdownOptionsType)
                //     .executeFromCache().toArray()
                //     .filter(cObject => JSON.parse((/**@type {string}*/ cObject.get(DropdownConfig.jsonProp))).entity === entity)
                //     [0].get(DropdownConfig.jsonProp);
                const dropdownConfig = JSON.parse(jsonString);
                dropdownOptions = dropdownConfig ?  dropdownConfig.options : [];
            }
            const updateHeight = () => {
                const element = document.getElementById(componentId);
                if (element && element.parentElement) {
                    $.set('Height', Math.max(element.parentElement.clientHeight, 70));
                }
            };

            let fetchOptions;
            if (dropdownOptions?.length > 0) {
                fetchOptions = () => {
                    return Promise.resolve(dropdownOptions);
                }
            } else {
                fetchOptions = async (searchValue) => {
                    return await getLookupDataSF(
                        entity,
                        selectedFilters,
                        searchValue,
                    );
                };
            }

            const onChangeHandler = (newSelection, selectedAll) => {
                const updatedFilters = {
                    ...selectedFilters,
                    [entity]: {
                        values: newSelection,
                        selectedAll: selectedAll,
                    },
                };

                const onChangeBrick = $.get('On Change');
                const [triggerInput, updatedFiltersInput] = onChangeBrick.getInputs();
                const [endOutput] = onChangeBrick.getOutputs();
                const onChangeBrick$ = $.runner(onChangeBrick)
                    .set(updatedFiltersInput, updatedFilters)
                    .trigger(triggerInput);
                onChangeBrick$.waitFor(endOutput).then(() => { onChangeBrick$.destroy(); });
            };

            let getOptionLabel = (item) => {
                if (typeof item.id === 'string' && item.id !== '' && entity !== SFFilterType.PLANT.key) {
                    return parseInt(item.id) ?
                        `${parseInt(item.id)} - ${item.description}` :
                        `${item.id}` + ((item.description && item.description !== 'null') ? `- ${item.description}` : '');;
                } else return `${item.description}`;
            };

            return <FiltersAutocomplete
                id={componentId}
                disabled={disabled}
                fetchOptions={fetchOptions}
                getOptionLabel={getOptionLabel}
                selectedOptions={selectedOptions}
                showSelectAll={showSelectAll}
                onChange={onChangeHandler}
                updateHeight={updateHeight}
                limitCheck={limitCheck}
            />;
        };
    }
}

registerBrick('0187ff7496ccf5a107fd', SFFiltersAutocomplete);
